// extracted by mini-css-extract-plugin
export default {"wrapperInput":"SearchYearAndMonth_wrapperInput__xV+52","groupInput":"SearchYearAndMonth_groupInput__U-gZ9"};